module.exports = __webpack_public_path__ + "img/bookmark-fill.41a6e656.svg";